import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: 'Work Sans',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '1.5rem',
    letterSpacing: '0.15px',
    paddingBottom: '0 !important',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    '&>*': {
      marginTop: '1.5rem !important',
    },
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '1.5rem',
    '&>*:last-child': {
      marginLeft: '1rem !important',
    },
  },
  leaveButton: {
    '&.MuiButton-outlined': {
      backgroundColor: '#fff',
      color: '#6387C5',
      border: '1px solid #6387C5',
    },
  },
  stayButton: {
    '&.MuiButton-contained': {
      backgroundColor: '#6387C5',
      color: '#fff',
      border: `1px solid #6387C5`,
      '&:hover': {
        backgroundColor: '#4067aa',
        borderColor: '#4067aa',
      },
      '&.Mui-disabled': {
        color: 'rgba(0, 0, 0, 0.26)',
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        borderColor: 'transparent',
      },
    },
  },
  required: {
    color: '#CC3D3F',
    /* Body 2 */
    fontFamily: 'Work Sans',
    fontSize: '15px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: '0.25px',
  },
});



// WEBPACK FOOTER //
// ./src/views/components/Forms/ESignatureForm/ESignaureFormStyles.js